export default {
    text_1: "Notifikácie",
    text_2: "Notifikácie",
    text_3: "Nastav si, kedy ti môžeme poslať e-mail.",
    text_4: "Emailové notifikácie",
    text_5: "Upozorniť e-mailom po otvorení ponuky klientom",
    text_6: "Keď si prvýkrát niekto otvorí tvoju ponuku ONLINE, pošleme ti o tom e-mail. Ak nechceš aby to sledovalo teba, nastav si svoju IP adresu v nastaveniach účtu.",
    text_7: "Uložiť",
    text_8: "SuperFaktúra",
    text_9: "Integrácie 3. strán",
    text_10: "Integruj DOFFERO s inými službami.",
    text_11: "Super Faktúra",
    text_12: "V tvojom účte v SuperFaktura v sekcii Nástroje nájdeš sekciu API, kde je potrebné skopírovať API kľúč. Po prepojení s DOFFEROM bude možné jednoducho kopírovať cenové ponuky z DOFFERO do SuperFaktura a vytvoriť z nich faktúru. Pre správne fungovanie odporúčame vyplnenie firemných údajov v",
    text_13: "nastaveniach firmy",
    text_14: "Prihlasovací e-mail do SuperFaktura",
    text_15: "API Klúč",
}